import agencyDashboardAPI from '@/utils/api/agencyDashboard';
import { genericError } from '@/utils/alerts.service';
import { tables } from '@/utils/tableProperties';

export const ourPublicProfiles = {
  namespaced: true,
  state: {
    query: '',
    count: 0,
    pageSize: 50,
    timeout: null,
    filters: {
      name: { value: '', keys: ['vendorName'] },
      status: { value: '', keys: ['status'] },
      completeness: { value: '', keys: ['completeness'] },
    },
    loading: false,
    rows: [],
    sortBy: '',
    columns: tables.agencyPublicProfilesVendors.fields,
  },
  getters: {
    getFilters(state) {
      return state.filters;
    },
    getRows(state) {
      return state.rows;
    },
    getColumns(state) {
      return state.columns;
    },
    getLoading(state) {
      return state.loading;
    },
  },
  mutations: {
    setDirectories(state, payload) {
      state.rows = payload;
    },
    setQuery(state, query) {
      state.query = query;
    },
    updateFilter(state, { fields, value, type, exact }) {
      state.filters[type] = { value: value, keys: fields, exact: exact };
    },

    setCount(state, count) {
      state.count = count;
    },
    setSort(state, sortBy) {
      state.sortBy = sortBy;
    },
    setLoading(state, bool) {
      state.loading = bool;
    },
  },
  actions: {
    resetQueryAndFilter({ dispatch, commit }) {
      commit('setQuery', '');
      dispatch('fetchOurPublicProfiles', 1);
    },
    async fetchOurPublicProfiles({ dispatch, commit, state }, page = 1) {
      commit('setLoading', true);
      let filterQuery =
        '&' +
        Object.keys(state.filters)
          .map(f => f + '=' + encodeURIComponent(state.filters[f].value))
          .join('&');
      try {
        const data = await agencyDashboardAPI.getPublicProfiles(
          page,
          state.pageSize,
          state.query,
          state.sortBy,
          filterQuery
        );
        commit('setCount', data.count);
        commit('setDirectories', data.results);
        return true;
      } catch {
        dispatch('showUserMessage', { ...genericError }, { root: true });
      } finally {
        commit('setLoading', false);
      }
    },
    updateQueryAndFilter(
      { commit, dispatch, state },
      { fields, value, type, exact }
    ) {
      if (type === 'name') {
        commit('setQuery', value);
      }
      commit('updateFilter', { fields, value, type, exact });

      clearTimeout(state.timeout);
      state.timeout = setTimeout(() => {
        dispatch('fetchOurPublicProfiles', 1);
      }, 500);
    },
    sortResults({ commit, dispatch }, sortKey) {
      commit('setSort', sortKey);
      dispatch('fetchOurPublicProfiles');
    },
  },
};
